import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-previewfile',
  templateUrl: './previewfile.component.html',
  styleUrl: './previewfile.component.css'
})
export class PreviewfileComponent implements OnInit, OnDestroy {
  @Input() fileUrl!: string;
  sanitizedUrl!: SafeResourceUrl;
 // fileUrl: string = '';
  fileName: string = '';
  isDialogOpen: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PreviewfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fileUrl: string, fileName: string },
    private sanitizer: DomSanitizer
  ) {
    this.fileUrl = data.fileUrl;
    this.fileName = data.fileName;
    
  }

  ngOnInit(): void {
    this.isDialogOpen = true;

    if (this.fileUrl) {
      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
    }
  }



  ngOnDestroy(): void {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
